import React, { createContext, useContext, useState } from 'react';
import { TabAnchor } from './components/product-tabs/types';

const initialValue: ITabNavContext = {
  activeTab: '',
  setActiveTab: () => {},
  shouldFetch: [],
  setShouldFetch: () => {},
};
const TabNavContext = createContext<ITabNavContext>(initialValue);

export const useTabNavContext = () => useContext(TabNavContext);

export const TabNavContextContainer: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = props => {
  const [shouldFetch, setShouldFetch] = useState<string[]>([]);
  const [activeTab, setActiveTab] = useState<string>(TabAnchor.ALL);

  return (
    <TabNavContext.Provider
      value={{
        activeTab,
        setActiveTab,
        shouldFetch,
        setShouldFetch,
      }}
    >
      {props.children}
    </TabNavContext.Provider>
  );
};

interface ITabNavContext {
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  shouldFetch: string[];
  setShouldFetch: React.Dispatch<React.SetStateAction<string[]>>;
}
